import { render, staticRenderFns } from "./UsersTable.vue?vue&type=template&id=66c3168a&scoped=true&"
import script from "./UsersTable.vue?vue&type=script&lang=js&"
export * from "./UsersTable.vue?vue&type=script&lang=js&"
import style0 from "./UsersTable.vue?vue&type=style&index=0&id=66c3168a&prod&lang=scss&scoped=true&"
import style1 from "./UsersTable.vue?vue&type=style&index=1&id=66c3168a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c3168a",
  null
  
)

export default component.exports